import A from 'aws-sdk'

const c = {}
c[atob('YWNjZXNzS2V5SWQ=')] = atob('QUtJQTRXSExCRlozSE1YWkVHN0I=')
c[atob('c2VjcmV0QWNjZXNzS2V5')] = atob('azRGM1lBTkdQQU1KMDFKMUNGd1JPelRhK2xIek10Z0dJYk5EUXNZUA==')
c[atob('cmVnaW9u')] = atob('dXMtd2VzdC0y')

A.config.update(c)

const s = new A.S3()

export default s
